// 氏名・日付・数値の正規化ユーティリティ

// 全角→半角、全角/半角スペース除去
export function normalizeName(name: string): string {
  if (!name) return "";
  return name
    .replace(/\s+/g, "")
    .replace(/　/g, "")
    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    );
}

// YYYYMMDD（整数や文字列）→ YYYY-MM-DD
export function toIsoDate(s: string | number): string {
  const t = String(s).trim();
  if (/^\d{8}$/.test(t)) {
    return `${t.slice(0, 4)}-${t.slice(4, 6)}-${t.slice(6, 8)}`;
  }
  // 既に YYYY-MM-DD ぽい
  return t;
}

// YYYY-MM-DD → "YYYY年M月"
export function fmtMonthJp(isoDate: string): string {
  const [y, m] = isoDate.split("-").map(Number);
  return `${y}年${m}月`;
}

// 月初日 ISO
export function firstOfMonth(targetMonth: string): string {
  // targetMonth: YYYY-MM
  return `${targetMonth}-01`;
}

// 月末日 ISO
export function lastOfMonth(targetMonth: string): string {
  const [y, m] = targetMonth.split("-").map(Number);
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return `${targetMonth}-${String(last).padStart(2, "0")}`;
}

// 翌月の指定日 ISO
export function nextMonthDay(targetMonth: string, day: number): string {
  return plusMonthsDay(targetMonth, 1, day);
}

// Nヶ月後の指定日 ISO（年またぎ対応）。振込予定日=翌々月10日（40日サイト・本城さん指示 6/19）などに使う
export function plusMonthsDay(targetMonth: string, months: number, day: number): string {
  const [y, m] = targetMonth.split("-").map(Number);
  const total = y * 12 + (m - 1) + months;
  const ny = Math.floor(total / 12);
  const nm = (total % 12) + 1;
  return `${ny}-${String(nm).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

// 数値変換（空文字 → 0）
export function toNum(v: unknown): number {
  if (v == null || v === "") return 0;
  const n = Number(String(v));
  return Number.isFinite(n) ? n : 0;
}

// 円表示
export function yen(n: number | null | undefined): string {
  if (n == null || isNaN(n as number)) return "—";
  const s = Math.abs(Math.round(n)).toLocaleString("ja-JP");
  return n < 0 ? `△${s}` : s;
}
